<template>
  <div class="date-paner">
    <div class="date-header">
      <!-- last -->
      <div class="last-date">
        <!-- 上一年 -->
        <i class="el-icon-d-arrow-left" @click="switchYear(--year)"></i>
        <!-- 上一月 -->
        <i class="el-icon-arrow-left" @click="switchMonth(--month)"></i>
      </div>
      <!-- change date -->
      <div class="change-date">
        <!-- 下一年 -->
        <span class="change-date-year">{{ $t('1096') }}</span>
        <span class="change-date-year">{{ formate({ value: year }) }}</span>
        <!-- 下一月 -->
        <span class="change-date-year">{{ $t('1333') }}</span>
        <span class="change-date-month">{{ formate({ value: month, type: 'month' }) }}</span>
      </div>
      <!-- next -->
      <div class="next-date">
        <i class="el-icon-arrow-right" @click="switchMonth(++month)"></i>
        <i class="el-icon-d-arrow-right" @click="switchYear(++year)"></i>
      </div>
    </div>
    <!-- body -->
    <div class="date-body">
      <!-- week -->
      <ul class="date-body-week">
        <li v-for="item in week" :key="item">{{ item }}</li>
      </ul>
      <!-- day -->
      <table class="table-date">
        <tr v-for="(i, index) in 6" :key="index">
          <td v-for="(item, num) in 7" :key="num + 7">
            <div :class="createClass(createIndex(index, num))" @click="handlerClickSelect(createIndex(index, num))">
              {{ createIndex(index, num).value }}
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import UDate from './formateDate'

export default {
  name: 'date',
  props: {
    // 日程列表
    includeSchedule: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const $t = this.$t
    return {
      year: UDate.year,
      month: UDate.month,
      // 列表
      tableData: [],
      week: [$t('1121'), $t('1122'), $t('1123'), $t('1124'), $t('1125'), $t('1126'), $t('1127')],
      selectDate: ''
    }
  },
  mounted() {
    // 初始化日期
    this.formateDate()
  },

  methods: {
    // 下标数据
    createIndex(row, col) {
      const params = this.tableData[row * 7 + col]
      return params || {}
    },
    // 生成每个日期
    createDateArray(params) {
      const { type, value } = params
      if (!type) return ''
      let month = this.month
      let year = this.year
      // 格式化当前下标日期
      switch (type) {
        case 'next':
          month++
          if (month < 0) {
            month = 11
            year--
          }
          if (month > 11) {
            month = 0
            year++
          }
          break
        case 'last':
          month--
          if (month < 0) {
            month = 11
            year--
          }
          if (month > 11) {
            month = 0
            year++
          }
          break
      }
      return { year, month, date: value, DateObj: new Date(year, month, value) }
    },
    // 生成class
    createClass(params) {
      const { type, value } = params
      if (!type) return ''
      const { year, month } = this.createDateArray(params)
      // 当前日期
      const nowDate = new Date()
      const nYear = nowDate.getFullYear()
      const nMonth = nowDate.getMonth()
      const nDate = nowDate.getDate()
      // 选中日期
      const selectClass = this.isSelectDate(params)
      // 展示spot
      const spot = this.addSpot(params) ? 'select-spots' : ''
      if (selectClass) return `${selectClass} ${spot}`
      // 判断是否为当前日期
      if (Number(year) === nYear && Number(month) === nMonth && Number(value) === nDate) {
        return 'current-date-nums ' + spot
      }
      // 非选中月日期
      if (type !== 'current') return 'last-date-nums ' + spot
      return spot
    },
    // 选中日期class
    isSelectDate(params) {
      if (!this.selectDate) return false
      const { year, month, date } = this.createDateArray(params)
      const nYear = this.selectDate.getFullYear()
      const nMonth = this.selectDate.getMonth()
      const nDate = this.selectDate.getDate()
      // 判断是否为当前日期
      if (Number(year) === nYear && Number(month) === nMonth && Number(date) === nDate) {
        return 'select-date-nums'
      }
    },
    // 点击事件
    handlerClickSelect(params) {
      const { year, month, date } = this.createDateArray(params)
      this.year = year
      this.month = month
      this.formateDate()
      this.selectDate = new Date(year, month, date)
      this.$emit('change', this.selectDate)
    },
    // 添加Spot
    addSpot(params) {
      if (!this.includeSchedule.length) return false
      const { year, month, date } = this.createDateArray(params)
      const status = this.includeSchedule.some(item => {
        const [ny, nm, nd] = item.split('-')
        if (Number(ny) === Number(year) && Number(nm - 1) === Number(month) && Number(nd) === Number(date)) {
          return true
        }
      })
      return status
    },
    formate(params) {
      if (params.type && params.type === 'month') return params.value + 1
      return params.value
    },
    // 生成列表
    formateDate() {
      // 本月天数
      const dateCount = UDate.getDate({ year: this.year, month: this.month })
      const firstDay = UDate.getDay({ year: this.year, month: this.month, date: 1 })
      // 上月天数
      const lastDateCount = UDate.getDate({ year: this.year, month: this.month - 1 })
      const beforeData = Array.from({ length: firstDay }, (value, index) => index)
      // 数据生成
      // 上月展示日期
      const lastDate = beforeData
        .map((item, index) => ({
          type: 'last',
          value: lastDateCount - index
        }))
        .reverse()
      // 本月展示日期
      const currentDate = Array.from({ length: dateCount }, (value, index) => {
        const num = index + 1
        return {
          type: 'current',
          value: num < 10 ? `0${num}` : num
        }
      })
      // 下月日期展示
      const nextDate = Array.from({ length: 42 - (lastDate.length + currentDate.length) }, (value, index) => {
        const num = index + 1
        return {
          type: 'next',
          value: num < 10 ? `0${num}` : num
        }
      })
      // 生成日期
      this.tableData = [...lastDate, ...currentDate, ...nextDate]
    },
    // 切换月份
    switchMonth(month) {
      this.month = month
      if (month < 0) {
        this.month = 11
        this.year -= 1
      }
      if (month > 11) {
        this.month = 0
        this.year += 1
      }
      this.formateDate()
    },
    // 切换年份
    switchYear(year) {
      this.year = year
      this.formateDate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
$activeCOlor: rgba($theme, 0.7);
$warning: #f7aa06;
.date-paner {
  color: #606266;
  font-family: Microsoft YaHei;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 4px;
  line-height: 30px;
  padding: 10px 15px;
  min-width: 300px;
  user-select: none;
  max-width: 340px;
  &:hover {
    transition: all 0.3s;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .date-header {
    display: flex;
    text-align: center;
    i {
      height: 100%;
      display: block;
      cursor: pointer;
      display: block;
      margin: 0 5px;
      display: flex;
      align-items: center;
      &:hover {
        color: $theme;
      }
      &:active {
        color: $activeCOlor;
      }
    }
    .last-date {
      display: flex;
      align-items: center;
    }
    .next-date {
      display: flex;
      align-items: center;
    }
    .change-date {
      width: 80%;
      font-weight: bold;
      > span {
        height: 100%;
        display: inline-block;
        vertical-align: middle;
        transform: translateY(2px);
        margin: 0 5px;
        cursor: pointer;
        &:hover {
          color: $theme;
        }
        &:active {
          color: $activeCOlor;
        }
      }
    }
  }
  .date-body {
    padding: 0 2px;
    margin-top: 16px;
    .select-spots {
      &:after {
        display: block !important;
      }
    }
    // 当前日期
    .current-date-nums {
      background: rgba($theme, 0.3);
    }
    // 选中日期
    .select-date-nums {
      background: $theme !important;
      color: #fff !important;
    }
    // 非展示月日期
    .last-date-nums {
      color: #adadad;
      &:hover {
        color: $theme;
      }
    }
    .table-date {
      margin-top: 5px;
      width: 100%;
      text-align: center;
      font-size: 12px;
      td {
        > div {
          transition: all 0.3s;
          cursor: pointer;
          &:hover {
            color: $theme;
          }
          &:active {
            color: #000;
          }
          width: 80%;
          margin: 0 auto;
          border-radius: 50%;
          position: relative;
          padding-bottom: 80%;
          height: 0;
          &:after {
            content: '';
            display: none;
            position: absolute;
            width: 3px;
            height: 3px;
            border-radius: 2px;
            background: $warning;
            left: 50%;
            bottom: 8%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .date-body-week {
      display: flex;
      justify-content: space-between;
      li {
        width: calc(100% / 7);
        text-align: center;
        border-bottom: 1px solid #ebeef5;
        padding-bottom: 12px;
      }
    }
  }
}
</style>
